import { AlertTriangle, Eye, Loader2 } from "lucide-react";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { DOCUMENT_TYPE_LABELS } from "./Exports.constants";

export default function PreviewDialog({
  previewDoc, setPreviewDoc, previewError, previewLoading, previewBlobUrl, previewContainerRef,
  isPreviewPdf, isPreviewDocx,
}) {
  return (
    <Dialog open={!!previewDoc} onOpenChange={(open) => !open && setPreviewDoc(null)}>
      <DialogContent className="max-w-5xl h-[85vh] flex flex-col p-0 gap-0" data-testid="exports-preview-dialog">
        <DialogHeader className="border-b border-slate-200 p-4">
          <DialogTitle className="flex items-center gap-2"><Eye className="h-4 w-4" /> Anteprima documento</DialogTitle>
          <DialogDescription>
            {previewDoc?.file_name} · {previewDoc && DOCUMENT_TYPE_LABELS[previewDoc.document_type]}
          </DialogDescription>
        </DialogHeader>
        <div className="flex-1 overflow-auto bg-slate-50 p-2" data-testid="exports-preview-body">
          {previewError && <Alert variant="destructive"><AlertTriangle className="h-4 w-4" /><AlertDescription>{previewError}</AlertDescription></Alert>}
          {previewLoading && <div className="flex h-full items-center justify-center text-slate-500" data-testid="exports-preview-loading"><Loader2 className="h-6 w-6 animate-spin" /> Caricamento anteprima...</div>}
          {!previewLoading && isPreviewPdf && previewBlobUrl && (
            <iframe title="PDF preview" src={previewBlobUrl} className="h-full w-full rounded border border-slate-200 bg-white" data-testid="exports-preview-pdf" />
          )}
          {!previewLoading && isPreviewDocx && (
            <div ref={previewContainerRef} className="docx-preview-wrapper mx-auto max-w-4xl rounded border border-slate-200 bg-white p-4 shadow-sm" data-testid="exports-preview-docx" />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
